/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsLogsModule
 */

import { Pipe, PipeTransform } from '@angular/core';
import { transformSavedSearches } from '../utils/vs-logs-filters.utils';

/**
 * @description
 *     Transform saved searches data from a hash to an array.
 * @author Alex Klyuev
 */
@Pipe({
    name: 'transformSavedSearches',
})
export class TransformSavedSearches implements PipeTransform {
    /** @override */
    public transform = transformSavedSearches;
}
